/**
 * An id for something the server has not seen yet: a version 4 uuid, which is what
 * the server's own are, so it can keep it. The twin of `newUuid` in
 * `packages/limuzin_core/lib/src/ids.dart`.
 *
 * `crypto.randomUUID` is only there on a secure origin, which a phone on the dev
 * server's LAN address is not; the random bytes are there everywhere.
 */
export function newId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * The id an order is sent under: the same while the order is the same and has not
 * gone through, so a tap again after a lost answer is that order and not a second
 * (ADR 0030). The twin of `OrderName` in the rider app.
 */
export class OrderName {
  private id: string | null = null;
  private of: string | null = null;

  /** The id for an order of `what` — anything that says everything the order says. */
  idFor(what: unknown): string {
    const key = JSON.stringify(what);
    if (key !== this.of || this.id === null) {
      this.of = key;
      this.id = newId();
    }
    return this.id;
  }

  /** It went through: the next one is another. */
  done(): void {
    this.id = null;
    this.of = null;
  }
}
